module.exports = __webpack_public_path__ + "img/avatar.4788048f.png";